/* Reverse Retrograde – product photo normaliser (added Oct 2026)
   Studio shots are cropped differently per product, so some items look tiny in
   their tile and others fill it. This measures where the product sits inside
   each plain-background photo and scales/centres it so every product occupies
   about the same share of its tile. Lifestyle photos are left untouched. */
(function () {
  // Every product is centred and its longest side is drawn at a set share of the tile.
  // Shares come from Theme settings > Reverse clean-up; each photo carries its own value in
  // data-rr-size (set per collection in the product card templates).
  var SIZE = (window.rrFit && Number(window.rrFit.size) > 0 ? Number(window.rrFit.size) : 60) / 100;
  var MAX_UP = 2.2;    // never enlarge more than this (keeps photos sharp)
  var MIN_DOWN = 0.40; // never shrink below this
  var STORE = 'rrFit2:';
  // Measured ahead of time (same rule as below, from the 160px photo) so phones that blur or
  // add noise to canvas reads (iPhone Safari's fingerprinting protection) still size every
  // product the same. Key = photo filename at 160px; value = [w, h, x0, x1, y0, y1, cut] or 0
  // (not a plain-background photo). Photos added later fall back to measuring in the browser.
  var BOXES = {"as-above-so-below-crop-tee-black-front_160x.jpg":[160,160,0.125,0.875,0.2813,0.7188,0],"as-above-so-below-crop-tee-black-back_160x.jpg":[160,160,0.125,0.875,0.2813,0.7188,0],"i-heart-esrever-crop-tee-creme-front_160x.jpg":[160,160,0.1313,0.8688,0.2813,0.7188,0],"i-heart-esrever-crop-tee-creme-back_160x.jpg":[160,160,0.1313,0.8688,0.2813,0.7188,0],"as-above-so-below-ls-front_160x.jpg":[160,160,0.0063,0.9938,0.15,0.8313,0],"as-above-so-below-ls-back_160x.jpg":[160,160,0.0063,0.9938,0.15,0.8313,0],"IMG-5772_160x.png":[160,120,0,0.9812,0.0333,0.975,1],"from-the-mud-zip-front_160x.jpg":[160,160,0,1,0.0813,0.9125,0],"from-the-mud-zip-back_160x.jpg":[160,160,0,1,0.0813,0.9313,0],"balance-hoodie-front_160x.jpg":[160,160,0.0125,0.9938,0.0625,0.9375,0],"balance-hoodie-back_160x.jpg":[160,160,0,1,0.0813,0.9313,0],"fix-myself-tee-front_160x.jpg":[160,160,0.0187,0.9812,0.125,0.9,0],"IMG-0048_160x.jpg":[160,160,0.025,0.975,0.125,0.9,0],"IMG-9708_160x.jpg":[160,160,0.0187,0.9812,0.125,0.9,0],"IMG-9707_160x.jpg":[160,160,0.025,0.975,0.125,0.9,0],"2A2F23B5-0BB8-4964-A756-5753E69D7F02_160x.jpg":[160,236,0.1375,0.9,0.6229,0.7415,0],"CCA7C6BB-F36D-4CF6-ABB5-C65D98F7F051_160x.jpg":0,"E35FF11D-92A8-4671-A933-EAFE3EF5FA20_160x.jpg":[160,189,0.1563,0.8313,0.5979,0.7672,0],"65F9ECC8-6356-4747-BA8F-A5BC7EF28CB2_160x.jpg":0,"IMG-9652_160x.jpg":[160,203,0.1437,0.8313,0.5961,0.7537,0],"EAB90196-B703-49A9-AE45-82895ADB5F75_160x.jpg":0,"IMG-9599_160x.jpg":[160,222,0.1313,0.9,0.6036,0.7297,0],"B212C818-F375-4FC9-B047-DD2C793CA972_160x.jpg":0,"IMG-9336_160x.jpg":[160,160,0.025,0.9812,0.125,0.9,0],"IMG-9335_160x.jpg":[160,160,0.025,0.975,0.125,0.9,0],"B7EFCE8D-9008-4EFB-8C44-A701DD786D99_160x.jpg":[160,212,0.0187,0.9125,0.5708,0.7736,0],"31A4B558-2A18-4AB5-8754-5FB002D4E53C_160x.jpg":0,"pink-lotus-hd_160x.jpg":[160,187,0.0313,0.9563,0.5722,0.8396,0],"FullSizeRender_c9ea6d13-20ed-4c22-adb2-6c909b8f3790_160x.jpg":[160,160,0,1,0.1125,0.75,0],"98861037-F72B-4456-8D54-4FEDA6DA6108_160x.jpg":[160,244,0.0437,0.9437,0.6066,0.7828,0],"841ED89C-3F3B-4CE5-B513-2522D4C3A2C8_160x.jpg":0,"B51F424E-48A8-499A-927F-0A14F8C7AA1F_160x.jpg":[160,160,0.1187,0.9,0.5687,0.8562,0],"F954CBAD-5086-4CA8-97EC-8CD66926B7B9_160x.jpg":0,"FullSizeRender_20fda422-eac7-48b9-9bc6-2a834eac453d_160x.jpg":[160,281,0.0313,0.975,0.6014,0.7616,0],"BEEF9455-0F74-4153-B919-12D7A362156F_160x.jpg":0,"E5C14038-0AE0-410E-B85C-BEA66818A131_160x.jpg":[160,254,0,0.9875,0.563,0.7559,0],"DA9E832A-DEA5-406C-8028-E91B277F07EF_160x.jpg":0,"FBE0EC49-B43C-4CB8-9E5E-A9D88217B8E8_160x.jpg":[160,284,0.025,0.9938,0.1373,0.7993,0],"reverse-tote-back-v3_160x.jpg":[160,176,0.2062,0.8,0.0511,0.9489,0],"chocolate-hat-front-v4_160x.jpg":[160,219,0.125,0.8125,0.3196,0.7215,0],"6B96F867-1815-428A-A116-9DA66BB8C393_160x.jpg":[160,160,0.0375,0.9812,0.2938,0.7562,0],"reverse-222-front_160x.jpg":[160,160,0.0187,0.9812,0.125,0.9,0],"reverse-222-tee-back_160x.jpg":[160,160,0.025,0.975,0.125,0.9,0],"3CBBD94A-6A14-48FF-A449-0C65E0174E0D_160x.jpg":[160,219,0.0563,0.8812,0.2968,0.7397,0],"36F07F1A-A019-4C58-A71F-71A2D1802EE0_160x.jpg":0,"plain-sight-hat-front-v4_160x.jpg":[160,219,0.1313,0.8063,0.3196,0.7169,0],"CB79EB69-3041-41D4-AE69-63BE3F61749A_160x.jpg":0,"final-days-hat-front-v2_160x.jpg":[160,219,0.0875,0.85,0.3105,0.7306,0],"IMG-8636_160x.jpg":[160,160,0.0437,1,0.0875,0.7375,0],"Sweats_final_6_160x.png":[160,160,0.1688,0.825,0.1,0.975,0],"IMG_5178_160x.jpg":0,"jorts1_160x.png":[160,160,0.1125,0.8938,0.2313,0.9875,0],"jorts_back_1_160x.png":[160,160,0.1,0.9313,0.1688,0.9625,0],"awakening-polo-hd_160x.png":[160,160,0.0187,0.9938,0.1313,0.9,1],"CF719E5E-D149-48D1-AA2C-BF8210B32D17_160x.png":0,"energy-is-everything-tee-hd_160x.png":[160,125,0.0375,1,0.04,1,1],"tee_2_2_160x.png":[160,133,0,1,0.0226,0.9624,1],"tote_160x.jpg":[160,160,0.1938,0.8063,0.1625,0.775,0],"totecloseup_160x.jpg":[160,160,0,1,0.1625,0.8375,0],"IMG_5951_ffc338aa-da1f-46b8-92f1-a6445c0ead8f_160x.jpg":[160,160,0.2813,0.725,0.2687,0.725,0],"IMG_5954_0ec27b85-8111-44b6-a69e-828380e41ed6_160x.jpg":[160,160,0.1062,0.775,0.3187,0.7125,0],"frontred_160x.jpg":[160,160,0.2625,0.7188,0.2625,0.725,0],"leftred_160x.jpg":[160,160,0.1062,0.775,0.325,0.7,0],"IMG_5050_160x.jpg":[160,160,0.2562,0.725,0.2687,0.7188,0],"IMG_5056_160x.jpg":[160,160,0.1187,0.7937,0.3187,0.7125,0],"mcw-2_160x.jpg":[160,160,0.1563,0.875,0.075,0.9,0],"steven_160x.jpg":[160,284,0.1563,0.8688,0.0634,1,0],"BC4368CC-0E7A-4738-B950-7D9B31DD98F3_160x.png":[160,213,0.1688,0.8875,0.1408,0.9155,0],"11E01245-E011-4D9D-8918-61BF6168F274_160x.png":[160,213,0.15,0.925,0.1549,0.9202,0],"IMG_2624_160x.jpg":[160,160,0.275,0.7188,0.2687,0.7125,0],"IMG_2625_160x.jpg":[160,160,0.1125,0.8,0.3312,0.7188,0],"IMG_2621_160x.jpg":[160,160,0.275,0.7188,0.2813,0.7,0],"IMG_2622_160x.jpg":[160,160,0.125,0.775,0.325,0.7188,0],"IMG-2630_160x.jpg":[160,160,0.2813,0.725,0.275,0.7125,0],"hat_2_bf8f0852-1814-4869-839c-a088ccc3d27b_160x.png":[160,160,0.05,0.9437,0.225,0.7125,0],"cut-off-tee-hd_160x.jpg":[160,160,0.1625,0.85,0.0813,0.925,0],"IMG_5952_fcbcc2bf-7530-4276-93f7-af1ea3d82280_160x.jpg":[160,160,0.275,0.7312,0.2625,0.725,0],"IMG_5955_edee81e2-533d-48d7-9d2a-aeae1baf48d0_160x.jpg":[160,160,0.125,0.775,0.3187,0.7125,0],"IMG_5947_be966e1c-4dca-403f-9c7a-efa1733be2fc_160x.jpg":[160,160,0.2687,0.725,0.2687,0.725,0],"IMG_5948_64cf6f26-c5f3-43e0-a143-ee066cb2fa5f_160x.jpg":[160,160,0.125,0.7875,0.3375,0.7063,0],"IMG_5266_160x.jpg":[160,160,0.2687,0.7375,0.2813,0.7125,0],"IMG_5264_160x.jpg":[160,160,0.1812,0.825,0.3375,0.7188,0],"IMG_5049_160x.jpg":[160,160,0.2437,0.7375,0.2813,0.7188,0],"IMG_5055_160x.jpg":[160,160,0.125,0.7937,0.325,0.7063,0],"IMG_5053_160x.jpg":[160,160,0.25,0.7312,0.2687,0.7125,0],"IMG_5061_160x.jpg":[160,160,0.1563,0.875,0.3063,0.7063,0]};
  window.rrFitStarted = true;
  var cache = {};

  function smallUrl(src) {
    var parts = src.split('?');
    var path = parts[0].replace(/_(?:\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, '');
    path = path.replace(/\.([a-z0-9]+)$/i, '_160x.$1');
    return path + (parts[1] ? '?' + parts[1] : '');
  }

  function measure(src, done) {
    if (cache[src] !== undefined) { done(cache[src]); return; }
    var file = smallUrl(src).split('?')[0].split('/').pop();
    var key = STORE + file;
    if (Object.prototype.hasOwnProperty.call(BOXES, file)) {
      var b = BOXES[file];
      cache[src] = b ? { w: b[0], h: b[1], x0: b[2], x1: b[3], y0: b[4], y1: b[5], cut: !!b[6] } : null;
      done(cache[src]); return;
    }
    try {
      var saved = window.localStorage.getItem(key);
      if (saved) { cache[src] = JSON.parse(saved) || null; done(cache[src]); return; }
    } catch (e) {}
    var im = new Image();
    im.onload = function () {
      var result = null;
      try {
        var w = im.naturalWidth, h = im.naturalHeight;
        if (w > 4 && h > 4) {
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var ctx = c.getContext('2d');
          ctx.drawImage(im, 0, 0);
          var d = ctx.getImageData(0, 0, w, h).data;
          var px = function (x, y) { var i = (y * w + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; };
          var diff = function (a, b) { return Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) + Math.abs(a[2] - b[2]) + Math.abs(a[3] - b[3]); };
          var bg = px(1, 1);
          var corners = [px(w - 2, 1), px(1, h - 2), px(w - 2, h - 2)];
          var plain = true;
          for (var k = 0; k < corners.length; k++) { if (diff(bg, corners[k]) > 30) plain = false; }
          var light = bg[3] < 20 || (bg[0] > 225 && bg[1] > 225 && bg[2] > 225);
          if (plain && light) {
            // count product pixels per row and column; a row/column only counts when several
            // pixels in it differ from the background, so stray noisy pixels can't stretch the box
            var minX = w, minY = h, maxX = -1, maxY = -1, rows = new Array(h), cols = new Array(w), q;
            for (q = 0; q < h; q++) rows[q] = 0;
            for (q = 0; q < w; q++) cols[q] = 0;
            for (var y = 0; y < h; y++) {
              for (var x = 0; x < w; x++) {
                var i = (y * w + x) * 4;
                var df = Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2]) + Math.abs(d[i + 3] - bg[3]);
                if (df > 45) { rows[y]++; cols[x]++; }
              }
            }
            var needR = Math.max(2, Math.round(w * 0.01)), needC = Math.max(2, Math.round(h * 0.01));
            for (q = 0; q < h; q++) { if (rows[q] >= needR) { if (q < minY) minY = q; if (q > maxY) maxY = q; } }
            for (q = 0; q < w; q++) { if (cols[q] >= needC) { if (q < minX) minX = q; if (q > maxX) maxX = q; } }
            if (maxX >= minX && maxY >= minY) {
              result = { w: w, h: h, x0: minX / w, x1: (maxX + 1) / w, y0: minY / h, y1: (maxY + 1) / h, cut: bg[3] < 20 };
            }
          }
        }
      } catch (e) { result = null; }
      cache[src] = result;
      try { window.localStorage.setItem(key, JSON.stringify(result || 0)); } catch (e) {}
      done(result);
    };
    im.onerror = function () { cache[src] = null; done(null); };
    im.src = smallUrl(src);
  }

  function ready(img) { img.setAttribute('data-rr-ready', '1'); }

  function apply(img, m) {
    ready(img);
    if (!m) return;
    var tile = img.closest('.product-list__img-link');
    if (!tile) return;
    if (window.getComputedStyle(img).position !== 'absolute') return; // only the square-tile layout
    // photos with a transparent background are marked so the black theme can put them on charcoal
    if (!img.classList.contains('hover-image')) {
      if (m.cut) tile.classList.add('rr-cutout'); else tile.classList.remove('rr-cutout');
    }
    var tw = tile.clientWidth, th = tile.clientHeight;
    var ew = img.clientWidth, eh = img.clientHeight;
    if (!tw || !th || !ew || !eh) return;
    var k = Math.min(ew / m.w, eh / m.h);       // object-fit: contain
    var dw = m.w * k, dh = m.h * k;             // drawn photo size
    var bw = (m.x1 - m.x0) * dw, bh = (m.y1 - m.y0) * dh;
    var shareW = bw / tw, shareH = bh / th;
    var longest = Math.max(shareW, shareH);
    if (longest < 0.08) return;
    var own = Number(img.getAttribute('data-rr-size'));
    var s = (own > 0 ? own / 100 : SIZE) / longest;
    // per-product trim (window.rrFit.adjust = { 'product-handle': 0.9 }) for items that read too big
    var adj = window.rrFit && window.rrFit.adjust;
    if (adj) {
      var hm = (tile.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
      if (hm && Number(adj[hm[1]]) > 0) s = s * Number(adj[hm[1]]);
    }
    if (s > MAX_UP) s = MAX_UP;
    if (s < MIN_DOWN) s = MIN_DOWN;
    var cx = ((m.x0 + m.x1) / 2 - 0.5) * dw / ew * 100;
    var cy = ((m.y0 + m.y1) / 2 - 0.5) * dh / eh * 100;
    img.style.transform = 'translate(-50%,-50%) scale(' + s.toFixed(3) + ') translate(' + (-cx).toFixed(2) + '%,' + (-cy).toFixed(2) + '%)';
    img.setAttribute('data-rr-fit', s.toFixed(2));
  }

  function fit(img) {
    var src = img.currentSrc || img.getAttribute('src');
    if (!src) { ready(img); return; }
    setTimeout(function () { ready(img); }, 2500);
    measure(src, function (m) { apply(img, m); });
  }

  function watch(img) {
    if (img.__rrWatched) return;
    img.__rrWatched = true;
    if (img.complete && img.naturalWidth) fit(img);
    img.addEventListener('load', function () { fit(img); });
    img.addEventListener('error', function () { ready(img); });
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('img.product-list__product-img');
    for (var i = 0; i < list.length; i++) watch(list[i]);
  }

  function start() {
    scan(document);
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var nodes = records[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            if (nodes[j].nodeType === 1) scan(nodes[j].parentNode || document);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var list = document.querySelectorAll('img.product-list__product-img');
        for (var i = 0; i < list.length; i++) fit(list[i]);
      }, 200);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
